// src/store/index.js
// Redux store configuration

import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage for web

import { baseApi } from '../shared/api-client';
import authReducer from './slices/authSlice';
import cartReducer from './slices/cartSlice';

// Persist configuration for auth slice
const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['user', 'accessToken', 'refreshToken', 'isAuthenticated', 'delegations', 'activeDelegationTenantId'],
};

const persistedAuthReducer = persistReducer(authPersistConfig, authReducer);

// Persist cart to localStorage (non-sensitive data)
const cartPersistConfig = {
  key: 'cart',
  storage,
};

const persistedCartReducer = persistReducer(cartPersistConfig, cartReducer);

// Configure the Redux store
export const store = configureStore({
  reducer: {
    // Auth slice with persistence
    auth: persistedAuthReducer,

    // Cart slice with persistence
    cart: persistedCartReducer,

    // RTK Query API slice
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(baseApi.middleware),
});

// Enable refetchOnFocus and refetchOnReconnect behaviors
setupListeners(store.dispatch);

// Create persistor for redux-persist
export const persistor = persistStore(store);

// Export types for TypeScript (optional, but good to have for future)
export default store;
